var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ethereum_icon",
    "data-name": "Ethereum icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 32,
    height: 32,
    rx: 12,
    transform: "translate(0 32) rotate(-90)",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(10 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2487096444368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M6,0,0,9.9l6,3.536L11.955,9.91Z",
    fill: "#62688f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M2922.09,0V13.432l5.957-3.522Z",
    transform: "translate(-2916.093)",
    fill: "#454a75",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M6,0,0,9.9l6-2.72L11.955,9.91Z",
    fill: "#8a92b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M2922.09,0V7.177l5.957,2.733Z",
    transform: "translate(-2916.093)",
    fill: "#62688f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M13.2,5373.541l5.97,8.4,5.974-8.4-5.974,3.526Z",
    transform: "translate(-13.173 -5362.511)",
    fill: "#8a92b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M2921.97,5381.943l5.974-8.4-5.974,3.526Z",
    transform: "translate(-2915.973 -5362.511)",
    fill: "#62688f",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.1959c244502690c045a05c58bc32ecef.svg";
export { ForwardRef as ReactComponent };